<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow title="批注列表" @click-left="onClickLeft">
      <template #right>
        <van-icon @click="onCommentAdd" name="plus" size="20"/>
      </template>
    </van-nav-bar>
    <van-empty description="暂无数据" v-if="emptyShow"/>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad">
        <van-card v-for="item in list" :key="item.id"
                  :title=item.createUserName
                  :desc=item.flowComment>
          <template slot="tags">
            <van-tag plain type="danger">{{ item.taskName }}</van-tag>
          </template>
          <template slot="footer">
            <div>{{ item.createTime }}</div>
          </template>
        </van-card>
      </van-list>
    </van-pull-refresh>
    <van-dialog v-model="show" title="添加批注" show-cancel-button @confirm="saveComment">
      <van-field
        v-model="commnetVal"
        rows="3"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入批注内容"
        show-word-limit
      />
    </van-dialog>
  </div>
</template>

<script>
import {Toast} from "vant";
import {isWechat} from "../../utils/util";

export default {
  name: "FlowComment",
  data() {
    return {
      list: [],
      taskId: '',
      taskName: '',
      processInstanceId: '',
      businessId: '',
      processDefinitionKey: '',
      loading: false,
      finished: false,
      refreshing: false,
      userId: '',
      finishedText: "没有更多了",
      emptyShow: false,
      listIcon: "../../../static/images/flowlist.png",
      showPopover: false,
      actions: [
        {text: '添加批注', value: 1, icon: 'records'},
      ],
      show: false,
      commnetVal: '',
    };
  },
  mounted() {
    if(!isWechat()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.businessId = this.$route.query.businessId;
    this.processDefinitionKey = this.$route.query.processDefinitionKey;
    this.taskId = this.$route.query.taskId;
    this.taskName = this.$route.query.taskName;
    this.processInstanceId = this.$route.query.processInstanceId;
  },
  methods: {
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      this.getFlowCommentList();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getFlowCommentList: function () {
      this.$fetch("/pipe-line-api/blade-manager/flowComment/list", {
        processInstanceId: this.processInstanceId,
        bizId: this.businessId,
        isDeleted: 0,
        current: 0,
        size: 100,
      }).then(
        res => {
          const data = res.data;
          this.list = data.records;
          if (this.list.length > 0) {
            this.emptyShow = false;
            this.finishedText = "没有更多了";
          } else {
            this.emptyShow = true;
            this.finishedText = "";
          }
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
          console.log("返回的数据：" + JSON.stringify(this.list));
        },
        error => {
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      );
    },
    jumpFlowDetail: function (taskId, processInstanceId, businessId, processDefinitionKey) {
      this.$router.push({
        path: "/pipeflow/FlowDetail",
        query: {
          taskId: taskId,
          processInstanceId: processInstanceId,
          businessId: businessId,
          processDefinitionKey: processDefinitionKey
        }
      });
    },
    onSearch(val) {

    },
    clear() {
      this.onRefresh();
    },
    input(val) {
      if (!val) {
        this.onRefresh();
      }
    }, onClickLeft: function () {
      this.backToDetail();
    },
    backToDetail: function () {
      this.$router.push({
        path: "/pipeflow/FlowApprove",
        query: {
          taskId: this.taskId,
          processInstanceId: this.processInstanceId,
          businessId: this.businessId,
          processDefinitionKey: this.processDefinitionKey
        }
      });
    },
    onCommentAdd: function () {
      this.show = true;
    },
    saveComment() {
      const params = {
        bizId: this.businessId,
        processInstanceId: this.processInstanceId,
        flowComment: this.commnetVal,
        taskId: this.taskId,
        taskName: this.taskName,
      }
      let url = '/pipe-line-api/blade-manager/flowComment/submit'
      this.$bodyPost(url, params).then(
        res => {
          const data = res.data;
          Toast('添加成功');
          this.onLoad();
        },
        error => {
        }
      );
    }
  },

}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/FlowComment.vue